export default __webpack_public_path__ + "de68d102d4770e46b01cf75096eabaa5.webp";